// extracted by mini-css-extract-plugin
module.exports = {"exerciseBox1":"L1_exerciseBox1__1DwOz","checked":"L1_checked__9woSS","bad":"L1_bad__1kqQc","correct":"L1_correct__1PbV4"};